import React from "react";

const dummyTariffs = [
  { hsCode: "8412", description: "Pumps", duty: "5%" },
  { hsCode: "8483", description: "Gear Assemblies", duty: "7%" },
  { hsCode: "8413", description: "Hydraulic Cylinders", duty: "6%" },
];

export default function SyntraMfgTariffsPage({ onClose }) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-700">Export Controls & Tariffs (Dummy Data)</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-gray-50 border rounded-lg">
          <thead>
            <tr className="text-left border-b">
              <th className="p-2">HS Code</th>
              <th className="p-2">Description</th>
              <th className="p-2">Duty</th>
            </tr>
          </thead>
          <tbody>
            {dummyTariffs.map((t, idx) => (
              <tr key={idx} className="border-b">
                <td className="p-2">{t.hsCode}</td>
                <td className="p-2">{t.description}</td>
                <td className="p-2">{t.duty}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
